module.exports = __webpack_public_path__ + "img/title-bg.7a4e18dd.png";